export interface TrendItem {
  title: string;
  tag: string;
  heat: string;
  hot?: boolean;
  note: string;
}

export interface FeatureArticle {
  id: string;
  category: string;
  title: string;
  summary: string;
  date: string;
  read: string;
  image: string;
  keywords: string[];
}

export interface CollectionItem {
  id: string;
  title: string;
  subtitle: string;
  desc: string;
  count: number;
  image: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface TestimonialItem {
  name: string;
  role: string;
  text: string;
}

export const heroStats = [
  { num: "1.2w+", label: "深度内容篇目" },
  { num: "36", label: "常驻栏目" },
  { num: "920w+", label: "累计阅读" },
  { num: "24h", label: "每日滚动更新" },
];

export const hotFeature: FeatureArticle = {
  id: "f-hot",
  category: "深扒头条",
  title: "「时间线还原」方法论：一条热搜是怎么从萌芽走向全网热议的",
  summary:
    "当一条公共话题快速升温时，信息往往以碎片、情绪与二手转述的形式四处流动。我们尝试用时间线还原的方式，把事件的起点、发酵节点与各方说法重新拼回一张清晰的地图，帮助读者更冷静地看待刷屏背后的来龙去脉。",
  date: "09-09",
  read: "8.4万",
  image:
    "https://readdy.ai/api/search-image?query=Cinematic%20dark%20editorial%20collage%20of%20social%20media%20timeline%20threads%20and%20news%20screens%20glowing%20against%20deep%20charcoal%20background%2C%20moody%20red%20and%20amber%20light%20streaks%2C%20abstract%20information%20flow%2C%20high%20contrast%20journalistic%20photography%2C%20clean%20minimal%20composition&width=1600&height=900&seq=hot-cover&orientation=landscape",
  keywords: ["时间线", "复盘", "方法论"],
};

export const trendingList: TrendItem[] = [
  { title: "口碑与流量之间，综艺嘉宾阵容的「热度焦虑」该冷静了吗", tag: "行业观察", heat: "329w", note: "阵容逻辑正在被重新审视" },
  { title: "粉丝考古热：为什么越来越多人回头翻看老作品", tag: "粉丝动向", heat: "281w", note: "二创社区里的怀旧浪潮" },
  { title: "代言官宣的节奏博弈：品牌为何开始「慢热」营销", tag: "品牌与代言", heat: "246w", note: "从抢首发到养长尾" },
  { title: "舞台直拍为什么成了「圈外」也爱看的内容", tag: "舞台与现场", heat: "213w", note: "真实现场感的稀缺价值" },
  { title: "一个镜头反复被讨论，综艺名场面到底靠什么出圈", tag: "影视综名场面", heat: "187w", note: "情绪价值与二次创作" },
  { title: "长剧与短剧的「时长之争」，谁在主导观众的注意力", tag: "行业观察", heat: "164w", note: "内容消费的两种节奏" },
  { title: "空降物料与预热造势：宣发节奏越来越「前置化」", tag: "行业风向", heat: "129w", note: "声量峰值不再只属于首播日" },
  { title: "同人二创的边界：从玩梗到侵权，那条线怎么划", tag: "考古与二创", heat: "98w", note: "创作自由与版权保护的双向讨论" },
];

export const featuredCategories: string[] = [
  "全部",
  "影视综名场面",
  "品牌与代言",
  "粉丝动向",
  "舞台与现场",
  "行业观察",
  "考古与二创",
];

export const featureArticles: FeatureArticle[] = [
  {
    id: "a1",
    category: "影视综名场面",
    title: "一个镜头反复被讨论，综艺「名场面」到底靠什么出圈",
    summary:
      "从临场反应的戏剧性，到后期剪辑的情绪放大，名场面之所以能冲出圈层，往往是真实反应与二次创作的化学反应。我们拆解了几个被反复提及的片段，试着找到其中的共通密码。",
    date: "09-09",
    read: "8.2万",
    image:
      "https://readdy.ai/api/search-image?query=Stage%20spotlight%20on%20an%20empty%20drama%20set%20at%20night%2C%20warm%20amber%20studio%20lights%20against%20dark%20background%2C%20cinematic%20film%20noir%20atmosphere%2C%20editorial%20reportage%20photography%2C%20moody%20high%20contrast%2C%20minimal%20clean%20frame&width=800&height=500&seq=f1&orientation=landscape",
    keywords: ["名场面", "综艺", "出圈"],
  },
  {
    id: "a2",
    category: "品牌与代言",
    title: "代言官宣的节奏博弈：品牌为何开始「慢热」营销",
    summary:
      "过去的官宣追求一夜刷屏，如今越来越多品牌把声量拆成「预热—发酵—长尾」三段来经营。当热度峰值被主动拉平，代言营销的成败或许已不再只由首发日决定。",
    date: "09-09",
    read: "6.7万",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20still%20life%20of%20glossy%20product%20packaging%20and%20contract%20papers%20on%20warm%20cream%20table%2C%20soft%20side%20lighting%2C%20amber%20and%20crimson%20accents%2C%20clean%20magazine%20style%2C%20journalistic%20photography%2C%20subtle%20shadows&width=800&height=500&seq=f2&orientation=landscape",
    keywords: ["代言", "营销", "宣发"],
  },
  {
    id: "a3",
    category: "粉丝动向",
    title: "粉丝考古热：为什么越来越多人回头翻看老作品",
    summary:
      "在快节奏的更新环境中，一批观众却逆向而行，回望数年前的老综艺、老舞台与旧访谈。考古的乐趣不只是怀旧，更是在时间差里重新发现被忽略的细节与真诚。",
    date: "09-08",
    read: "7.9万",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20audio%20cassette%20tapes%20and%20old%20photographs%20scattered%20on%20a%20desk%2C%20warm%20nostalgic%20amber%20lighting%2C%20film%20grain%2C%20cozy%20editorial%20scene%2C%20journalistic%20photography%2C%20soft%20faded%20tones%2C%20meaningful%20composition&width=800&height=500&seq=f3&orientation=landscape",
    keywords: ["考古", "怀旧", "二创"],
  },
  {
    id: "a4",
    category: "舞台与现场",
    title: "舞台直拍为什么成了「圈外」也爱看的内容",
    summary:
      "没有滤镜的临场状态、精准的动作细节与真实的互动反应，让直拍在精修舞台之外开辟了另一片天地。它提供的不是完美，而是「这一刻真切发生过」的现场感。",
    date: "09-08",
    read: "5.1万",
    image:
      "https://readdy.ai/api/search-image?query=Silhouette%20of%20performers%20on%20a%20large%20concert%20stage%20with%20warm%20spotlights%20and%20light%20haze%2C%20dramatic%20red%20and%20amber%20lights%2C%20live%20show%20atmosphere%2C%20editorial%20concert%20photography%2C%20high%20contrast%2C%20dark%20background%2C%20dynamic%20energy&width=800&height=500&seq=f4&orientation=landscape",
    keywords: ["舞台", "直拍", "现场"],
  },
  {
    id: "a5",
    category: "行业观察",
    title: "长剧与短剧的「时长之争」，谁在主导观众的注意力",
    summary:
      "当越来越多人习惯用倍速与切片消费内容，长叙事是否正在让位于「三分钟讲完一个故事」？这场时长之争背后，其实是两种观看习惯与内容供给逻辑的正面碰撞。",
    date: "09-07",
    read: "4.6万",
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20editorial%20view%20of%20a%20phone%20screen%20playing%20video%20next%20to%20an%20open%20book%20on%20a%20desk%2C%20split%20between%20digital%20and%20print%2C%20warm%20desk%20lamp%20light%2C%20moody%20journalistic%20photography%2C%20thoughtful%20composition&width=800&height=500&seq=f5&orientation=landscape",
    keywords: ["短剧", "长剧", "注意力"],
  },
  {
    id: "a6",
    category: "行业风向",
    title: "空降物料与预热造势：宣发节奏越来越「前置化」",
    summary:
      "从空降定档到物料分批释放，片方正在把悬念拆成更细的颗粒，一点一点喂养观众的期待。前置宣发的背后，是对注意力分散时代更精密的节奏管理。",
    date: "09-07",
    read: "3.9万",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20desk%20with%20poster%20mockups%20and%20marketing%20calendar%20and%20phone%20notifications%2C%20warm%20office%20lighting%2C%20amber%20and%20crimson%20accents%2C%20journalistic%20reportage%20photography%2C%20cluttered%20yet%20clean%20composition&width=800&height=500&seq=f6&orientation=landscape",
    keywords: ["宣发", "营销", "行业"],
  },
  {
    id: "a7",
    category: "考古与二创",
    title: "同人二创的边界：从玩梗到侵权，那条线怎么划",
    summary:
      "二创让作品的生命周期被无限拉长，也把「什么是合理使用」推到台前。我们梳理了创作自由、平台规则与版权保护之间的张力，以及几类最常见却容易被忽视的越界情形。",
    date: "09-06",
    read: "6.3万",
    image:
      "https://readdy.ai/api/search-image?query=Colorful%20paint%20and%20digital%20tablet%20sketches%20and%20copyright%20documents%20side%20by%20side%20on%20a%20studio%20desk%2C%20warm%20creative%20lighting%2C%20editorial%20photography%2C%20contrast%20between%20art%20freedom%20and%20rules%2C%20minimal%20clean%20style&width=800&height=500&seq=f7&orientation=landscape",
    keywords: ["二创", "版权", "边界"],
  },
  {
    id: "a8",
    category: "影视综名场面",
    title: "即兴的胜负手：那些计划之外却封神的综艺瞬间",
    summary:
      "剧本写不出最好的反应。当镜头恰好捕捉到主持人抛梗后嘉宾的三秒迟疑、选手的临场反击，节目就此获得无法复制的记忆点。盘点那些靠即兴翻盘的经典片段。",
    date: "09-06",
    read: "5.8万",
    image:
      "https://readdy.ai/api/search-image?query=Two%20silhouetted%20people%20laughing%20on%20a%20lit%20variety%20show%20stage%2C%20warm%20practical%20lights%20and%20soft%20bokeh%2C%20unscripted%20moment%2C%20editorial%20behind%20the%20scenes%20photography%2C%20amber%20tones%2C%20authentic%20lively%20atmosphere&width=800&height=500&seq=f8&orientation=landscape",
    keywords: ["即兴", "名场面", "综艺"],
  },
];

export const collections: CollectionItem[] = [
  {
    id: "c1",
    title: "年度大盘点",
    subtitle: "这一年的高光与争议",
    desc: "用编辑部视角把全年的出圈名场面、行业争议与舆论风向汇总成册，一次看完一年的热闹与门道。",
    count: 52,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20collage%20of%20annual%20review%20newspaper%20clippings%20and%20award%20trophies%20on%20dark%20background%2C%20crimson%20and%20gold%20accent%20lighting%2C%20premium%20yearbook%20aesthetic%2C%20journalistic%20photography%2C%20dramatic%20high%20contrast%2C%20clean%20layout&width=1200&height=760&seq=c1&orientation=landscape",
  },
  {
    id: "c2",
    title: "时间线还原",
    subtitle: "把碎片拼成完整脉络",
    desc: "针对发酵迅速的话题，从起点、节点到多方说法逐条补齐，帮你在信息洪流里建立自己的判断坐标。",
    count: 38,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20timeline%20of%20glowing%20data%20points%20and%20connecting%20threads%20over%20moody%20background%2C%20amber%20and%20crimson%20light%2C%20analytical%20journalistic%20style%2C%20deep%20charcoal%2C%20abstract%20flow%2C%20high%20contrast%20minimal&width=1200&height=760&seq=c2&orientation=landscape",
  },
  {
    id: "c3",
    title: "全网热议榜",
    subtitle: "谁在聊 · 为什么聊",
    desc: "追踪被反复提及的公共话题与讨论人群画像，从情绪出口到价值共鸣，读懂一场热议的温度与来由。",
    count: 45,
    image:
      "https://readdy.ai/api/search-image?query=Social%20media%20speech%20bubbles%20and%20hashtags%20floating%20in%20warm%20dark%20space%2C%20red%20amber%20and%20cream%20glow%2C%20digital%20debate%20atmosphere%2C%20editorial%203d%20abstract%2C%20vibrant%20but%20tasteful%2C%20high%20contrast&width=1200&height=760&seq=c3&orientation=landscape",
  },
  {
    id: "c4",
    title: "传闻求证站",
    subtitle: "让信息回到事实",
    desc: "面对真假难辨的说法，不传也不压，而是把信源、时间与证据摆到桌面上逐一核对，帮你把「听说」变成「可查证」。",
    count: 21,
    image:
      "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20newspaper%20articles%20and%20document%20files%20on%20a%20desk%2C%20fact%20checking%20concept%2C%20warm%20desk%20lighting%2C%20amber%20and%20crimson%20accents%2C%20journalistic%20photography%2C%20clean%20focused%20composition&width=1200&height=760&seq=c4&orientation=landscape",
  },
];

export const categoriesIntro: { name: string; desc: string; icon: string }[] = [
  { name: "影视综名场面", desc: "出圈片段拆解与记忆点复盘", icon: "ri-movie-2-line" },
  { name: "品牌与代言", desc: "官宣节奏与营销链路观察", icon: "ri-price-tag-3-line" },
  { name: "粉丝动向", desc: "考古、应援与社区文化", icon: "ri-heart-3-line" },
  { name: "舞台与现场", desc: "直拍、路演与真实现场", icon: "ri-radio-2-line" },
  { name: "行业观察", desc: "内容供给与商业模式分析", icon: "ri-bar-chart-box-line" },
  { name: "考古与二创", desc: "版权边界与创作生态", icon: "ri-video-upload-line" },
];

export const deepDive = {
  eyebrow: "编辑部专栏 · 深度解读",
  title: "「吃瓜」正在变慢：当围观从情绪走向方法论",
  paragraphs: [
    "过去，一条话题从爆出到翻篇可能只用一晚上；而现在，越来越多人愿意花上几天，把来龙去脉一点点追完。围观的方式正在从「先表态」转向「先弄清」，这背后是一种悄然生长的信息耐心。",
    "我们把这种变化称为「慢吃瓜」。它表现为对时间线的重视、对信源的追问、对多方说法的比对，以及对「带节奏」话语的警觉。观众不再满足于被告知结果，而是想自己走一遍推理的过程。",
    "这份耐心对内容创作者提出更高要求：情绪只能带来一次转发，而可查证的梳理能带来持续的信任。当一个账号愿意为一条复杂话题单独画清时间线、标明不确定性，它就完成了从「热闹的传声筒」到「可靠的信息坐标」的身份切换。",
  ],
  points: ["信源分级，不只转发单一说法", "时间线优先，先理脉络再谈立场", "保留不确定性，不轻易下结论"],
  image:
    "https://readdy.ai/api/search-image?query=Thoughtful%20reader%20studying%20documents%20and%20timelines%20under%20a%20warm%20desk%20lamp%20at%20night%2C%20surrounded%20by%20notes%20and%20screens%2C%20editorial%20journalism%20scene%2C%20amber%20crimson%20tones%2C%20cinematic%20moody%20lighting%2C%20high%20contrast%2C%20clean%20composition&width=1200&height=800&seq=deep&orientation=portrait",
};

export const faqs: FaqItem[] = [
  {
    q: "每日黑料到底更新什么内容？",
    a: "我们聚合全网热度高、讨论多的娱乐与舆论话题，用编辑部视角做热点榜单、时间线复盘、专题合集与栏目分类盘点。内容覆盖影视综艺名场面、品牌代言、粉丝动向、舞台现场与行业观察等方向。",
  },
  {
    q: "你们的内容是事实吗？如何保证信息准确？",
    a: "我们坚持「先梳理、再表态」，优先呈现多方说法并注明不确定性。对信源做分级核对，可查证的内容会尽量附上时间点与原始出处；暂时无法确认的会明确标注「求证中」，不替读者下结论。",
  },
  {
    q: "我有线索或想投稿/反馈，应该怎么做？",
    a: "欢迎通过页面底部的「联系与订阅」表单留言。投稿请尽量附上时间、来源等可核验信息；涉及个人隐私或未经证实的内容我们不会直接发布，会先做求证评估再决定是否跟进。",
  },
  {
    q: "转载或引用你们的内容需要注意什么？",
    a: "如需转载，请注明出处并保留原文时间线与求证说明，避免断章取义。未经授权的商业性批量抓取不在允许范围内，具体合作可走表单留档与我们联系。",
  },
  {
    q: "你们的栏目分类有哪些？想看某一类怎么快速定位？",
    a: "目前常驻六大方向：影视综名场面、品牌与代言、粉丝动向、舞台与现场、行业观察、考古与二创。你可以在「深扒精选」区域使用分类标签筛选，或使用顶部站内搜索按关键词定位。",
  },
  {
    q: "内容多久更新一次？",
    a: "热点类内容随话题热度实时跟进，榜单与深扒版块按天滚动更新，专题合集与编辑部专栏则按周产出沉淀性内容，保证既有追热的速度，也有复盘的深度。",
  },
];

export const testimonials: TestimonialItem[] = [
  {
    name: "阿澈",
    role: "追综爱好者 · 关注两年",
    text: "以前刷到热点总是一头雾水，现在习惯先来这里把时间线看完，条理清晰又不带情绪，适合我这种不喜欢只看单方说法的人。",
  },
  {
    name: "林小满",
    role: "娱乐行业从业者",
    text: "专栏和行业观察写得相对克制客观，对营销节奏、内容供给这类话题的分析能给我不少选题上的启发，平时会定期回来看更新。",
  },
  {
    name: "大鹅",
    role: "深夜冲浪选手",
    text: "求证站那栏我常驻，能把一团乱麻的说法拆开摆证据的不多，至少让我学会转发前先问一句「这是真的吗」。",
  },
];